import {useEffect, useState} from "react";
import axios from "axios";
import {
	GET_ALL_TICKET_ARCHIVIATI_URL,
} from "../../../../services/utils/ApiUrls";
import {getConfig} from "../../../../services/utils/ConfigUtils";

export default function useGetAllArchiviati(pageNumber, sort, dir, data) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [tickets, setTickets] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	
	
	useEffect(() => {
		setTickets([]);
	}, [sort, dir, data])
	
	useEffect(() => {
		setLoading(true);
		setError(false);
		axios({
			method: "POST",
			url: GET_ALL_TICKET_ARCHIVIATI_URL + pageNumber + "/" + sort + "/" + dir,
			data: {
				...data
			},
			...getConfig(),
		}).then(response => {
			let filtered = response.data;
			setTickets(prevState => {
				let newState = [...prevState, ...filtered];
				return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
			})
			setHasMore(filtered.length > 0);
			setLoading(false);
		}).catch(() => {
			setError(true);
			setLoading(false);
		})
		
	}, [pageNumber, sort, dir, data])
	
	return {loading, error, tickets, hasMore};
}
